// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"361":"0d903765","430":"f484961f","1438":"0d903765","3633":"d4dce4b7","4508":"b122c0be","5880":"9d658b7a","7035":"f484961f"}[chunkId] + ".chunk.css";
};